import axios from "axios"
import { BASE_URL } from "@/service_urls"

const partnerProfile = {
  uploadPartnerProfile: (organisation_id, formData) =>
    axios.post(
      `${BASE_URL}/organisation/${organisation_id}/document/partner_document`,
      formData
    ),

  getPartnerDocuments: (organisation_id, customer_id) =>
    axios.get(
      `${BASE_URL}/customer/partner_documents/?organisation_id=${organisation_id}&customer_id=${customer_id}`
    ),

  getPartnerDocumentFile: (organisation_id, document_id, preview = false) =>
    axios.get(
      `${BASE_URL}/organisation/${organisation_id}/document/${document_id}/file`,
      {
        params: { preview },
        responseType: "text"
      }
    ),
}

export default partnerProfile
